import UpsellPaymentBanner from './UpsellPaymentBanner.vue';

export default UpsellPaymentBanner;
